export function getCurrentFonts() {
  const ret = [];
  const it = document.fonts.values();
  let val = undefined;
  do {
    val = it.next();

    if (val.value) ret.push(val.value);
  } while (!val.done);

  return ret;
}
